import Vue from 'vue';

const esiaStore = Vue.observable({ esiaError: null });

export default esiaStore;



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/esia-store.js